import React from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const FilterBtn = ({ active, iconType, iconComponent, ...props }) => {
  return (
    <Button
      {...props}
      className={cn(styles.root, { [styles.isActive]: active })}
    >
      <Icon className={styles.icon} type={iconType} component={iconComponent} />
    </Button>
  );
};

export default FilterBtn;
